import { Entry } from 'contentful';
import { FAccordionRow } from './accordionRow.factory';
import { FCollectionGeneric } from './collectionGeneric.factory';
import {
  FElementEmbeddedInformationModal,
  FElementFeatureRow,
  FElementNbnOrderSummary,
  FLink,
  FPaymentMethod,
  FSystemIcon
} from './elements';
import { FEmail, FGenericInput, FPassword } from './inputs';
import { FGenericInputGroup } from './inputs/genericInputGroup.factory';
import {
  FLinkList,
  FLinkListItem,
  FMoleculeAlert,
  FMoleculeAsset,
  FMoleculeCallout,
  FMoleculeInformationPanel,
  FMoleculeMediaCaptionBlock,
  FMoleculeModal,
  FMoleculeProgressIndicator,
  FMoleculeRichText,
  FMoleculeText,
  FMoleculeTileHeader
} from './molecules';
import { FOrganismAddressCapture, FOrganismPromoCard, FOrganismVerificationCodeCapture } from './organisms';
import { parseFlexibleContent } from './parseFlexibleContent';
import { FReadOnlyRow } from './readOnlyRow.factory';
import { FSectionInfo } from './sections';

export const SCREEN_CMS_FACTORY_MAP = new Map([
  ['collectionGeneric', { factory: FCollectionGeneric }],
  ['elementAccordionRow', { factory: FAccordionRow }],
  ['elementEmbeddedInformationModal', { factory: FElementEmbeddedInformationModal }],
  ['elementFeatureRow', { factory: FElementFeatureRow }],
  ['elementLink', { factory: FLink }],
  ['elementNbnOrderSummary', { factory: FElementNbnOrderSummary }],
  ['elementPaymentMethod', { factory: FPaymentMethod }],
  ['elementReadOnlyRow', { factory: FReadOnlyRow }],
  ['elementSystemIcon', { factory: FSystemIcon }],
  ['inputEmail', { factory: FEmail }],
  ['inputGeneric', { factory: FGenericInput }],
  ['inputGenericGroup', { factory: FGenericInputGroup }],
  ['inputPassword', { factory: FPassword }],
  ['moleculeAlert', { factory: FMoleculeAlert }],
  ['moleculeAsset', { factory: FMoleculeAsset }],
  ['moleculeCallout', { factory: FMoleculeCallout }],
  ['moleculeRichText', { factory: FMoleculeRichText }],
  ['moleculeLinkList', { factory: FLinkList }],
  ['moleculeLinkListItem', { factory: FLinkListItem }],
  ['moleculeMediaCaptionBlock', { factory: FMoleculeMediaCaptionBlock }],
  ['moleculeModal', { factory: FMoleculeModal }],
  ['moleculeProgressIndicator', { factory: FMoleculeProgressIndicator }],
  ['moleculeText', { factory: FMoleculeText }],
  ['moleculeTileHeader', { factory: FMoleculeTileHeader }],
  ['moleculeInformationPanel', { factory: FMoleculeInformationPanel }],
  ['organismPromoCard', { factory: FOrganismPromoCard }],
  ['organismAddressCapture', { factory: FOrganismAddressCapture }],
  ['organismVerificationCodeCapture', { factory: FOrganismVerificationCodeCapture }],
  ['sectionInfo', { factory: FSectionInfo }]
]);

export const FGenericScreen = (data: Entry<any>): any => {
  const { content } = data.fields;

  return parseFlexibleContent(content, SCREEN_CMS_FACTORY_MAP);
};
